import { Component } from '@angular/core';

@Component({
  selector: 'eeule-admin-not-found',
  standalone: true,
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {

}
